import { EmptyState, FlexBox } from '@dixa/lib-shared-habla';
import { useNavigate } from 'react-router-dom';

import { AppPath } from 'utils/url/appPaths';

import Error404 from '../../images/404.png';
import Image from '../shared/Image/Image';

import styles from './notFound.module.scss';

type NotFoundProps = {
  navigatePath: AppPath;
  name: string;
};

export const NotFound = ({
  navigatePath,
  name,
}: NotFoundProps): JSX.Element => {
  const navigate = useNavigate();

  return (
    <FlexBox
      flexDirection="column"
      gap="400"
      alignItems="center"
      justifyContent="center"
      width="100%"
      height="100%"
      background="neutral.000"
    >
      <Image src={Error404} alt="404-img" className={styles.image} />

      <EmptyState
        title="Oops, page not found!"
        description="We can't seem to find the page you're looking for."
        icon={null}
        buttonProps={{
          children: `Go to ${name}`,
          onClick: () => navigate(navigatePath),
        }}
      />
    </FlexBox>
  );
};
